import React, { useEffect, useRef, useState } from 'react';

interface Props {
  popupList: CardProductAdvertise[];
  onChange: (v: CardProductAdvertisePackDetailReturnItemJson) => void;
}

export default function PopupQueueComponent({ popupList = [], onChange }: Props) {
  // 当前显示的弹窗索引
  const [currentIndex, setCurrentIndex] = useState(0);
  // 倒计时计时器引用
  const timerRef: any = useRef(null);
  // 当前显示的弹窗数据
  const [sortedPopups, setSortedPopups] = useState<CardProductAdvertise[]>([]);
  const [countDownNum, setCountDownNum] = useState(0);
  // 排序（越小优先级越高）
  useEffect(() => {
    if (!popupList || popupList.length === 0) return;

    const list = [...popupList].sort((a, b) => a?.sortNum! - b?.sortNum!);
    setSortedPopups(list);
    setCurrentIndex(0);
  }, [popupList]); //esline-disable-line

  // 自动倒计时
  useEffect(() => {
    if (timerRef.current) clearInterval(timerRef.current);

    if (sortedPopups.length === 0 || currentIndex >= sortedPopups.length) {
      return;
    }

    const currentPopup = sortedPopups[currentIndex];
    if (!currentPopup.countdown || currentPopup.countdown <= 0) return;

    // 初始化倒计时
    setCountDownNum(currentPopup.countdown);

    timerRef.current = setInterval(() => {
      setCountDownNum((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          closeCurrentPopup();
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [sortedPopups, currentIndex]); //esline-disable-line

  // 关闭当前弹窗，弹出下一个
  const closeCurrentPopup = () => {
    if (timerRef.current) clearInterval(timerRef.current);

    if (currentIndex < sortedPopups.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setCurrentIndex(sortedPopups.length);
    }
  };

  const currentPopup = sortedPopups[currentIndex];
  const showPopup = currentPopup && currentIndex < sortedPopups.length;

  return (
    <>
      {showPopup && (
        <div className="popup-mask d-flex-c ai-center">
          <div className="bw-100 d-flex-r ai-center jc-center pos-r">
            {(currentPopup?.countdown! ?? 0) > 0 && <div className="popup-countdown">{countDownNum}秒后关闭</div>}

            {currentPopup.businessJson?.item?.map((item: any, idx: number) => (
              <img
                key={idx}
                src={item.imgUrl}
                alt={`弹窗图片${idx}`}
                className="popup-img"
                onClick={() => onChange(item)}
              />
            ))}
          </div>
          <div className="close-btn" onClick={() => closeCurrentPopup()}>
            <img className="icon" src="/pic/icon_close_black.png" alt="" />
          </div>
        </div>
      )}
    </>
  );
}
